export default __webpack_public_path__ + "static/media/LJ1_EN.ef894551.mp4";